class ComplementaryProducts extends HTMLElement {
  constructor() {
    super();
    this.debounceHandlePopupOpen = this.debounce(
      this.handlePopupOpen.bind(this),
      200
    );
    this.debounceHandlePopupClose = this.debounce(
      this.handlePopupClose.bind(this),
      200
    );
    this.debounceHandleMultiSwatchAddToCart = this.debounce(
      this.handleMultiSwatchAddToCart.bind(this),
      200
    );
    this.debounceHandleSingleSwatchAddToCart = this.debounce(
      this.handleSingleSwatchAddToCart.bind(this),
      100
    );
  }

  connectedCallback() {
    this.init();

    // cart mode
    this.addToCartMode = this.getAttribute("data-add-to-cart-mode");

    // single swatch
    this.isSingleSwatchAvailable =
      this.getAttribute("data-single-swatch-available") === "true";
    this.singleSwatchId = this.getAttribute("data-single-swatch-id");

    // multi swatch
    this.isMultiSwatchAvailable =
      this.getAttribute("data-multi-swatch-available") === "true";
    this.multiSwatchId = this.getAttribute("data-multi-swatch-id");
  }

  init() {
    this.domElements();
    this.bindListeners();
  }

  domElements() {
    this.content = this.querySelector(".complementary__body");
    this.overLay = this.querySelector(".complementary__overlay");

    // btns
    this.multipleSwatchBtn = this.querySelector(
      "button.complementary__button.complementary__button--multi"
    );

    this.singleSwatchBtn = this.querySelector(
      "button.complementary__button.complementary__button--single"
    );

    this.triggerBtn = this.querySelector(
      "button.product-info__complementary-button"
    );

    // error
    this.errorEl = this.querySelector(".complementary__content--footer--error");
    this.errorMessage = this.querySelector(
      ".complementary__content--footer--error-message"
    );
  }

  bindListeners() {
    if (!this.clickHandler) {
      this.clickHandler = (e) => {
        if (e.target.closest(".product-info__complementary-button")) {
          this.debounceHandlePopupOpen(e);
          return;
        }
        if (
          e.target.closest(".complementary__overlay") ||
          e.target.closest(".complementary__close") ||
          e.target.closest(".complementary__button--close")
        ) {
          this.debounceHandlePopupClose(e);
          return;
        }

        // multi swatch
        if (e.target.closest("button.complementary__button--multi")) {
          this.debounceHandleMultiSwatchAddToCart(e);
          return;
        }
      };
    }
    this.removeEventListener("click", this.clickHandler);
    this.addEventListener("click", this.clickHandler);

    if (!this.variantUpdateHandler) {
      this.variantUpdateHandler = () => {
        this.content.classList.toggle("hidden", true);
        this.overLay.classList.toggle("hidden", true);

        // If a previous timer is pending, cancel it:
        if (this.hideShowTimer) {
          clearTimeout(this.hideShowTimer);
        }

        this.hideShowTimer = setTimeout(() => {
          this.content.classList.toggle("hidden", false);
          this.overLay.classList.toggle("hidden", false);
          this.hideShowTimer = null; // Reset the timer
        }, 200);
      };
    }
    document.removeEventListener(
      "variant:contentUpdated",
      this.variantUpdateHandler
    );
    document.addEventListener(
      "variant:contentUpdated",
      this.variantUpdateHandler
    );
  }

  debounce(fn, delay) {
    let timer;
    return function (...args) {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => fn(...args), delay);
    };
  }

  handlePopupOpen() {
    // if multi swatch is available only then open
    if (this.isMultiSwatchAvailable && this.multiSwatchId) {
      this.content.classList.add("complementary__body--open");
      this.content.classList.remove("complementary__body--closed");
      document.body.style.overflow = "hidden";
    }
    // adding cart to single swatch initially
    this.debounceHandleSingleSwatchAddToCart();
  }

  handlePopupClose() {
    this.content.classList.remove("complementary__body--open");
    this.content.classList.add("complementary__body--closed");
    document.body.style.overflow = "auto";
  }

  showCartErrorMessage(message) {
    this.errorEl.classList.remove(
      "complementary__content--footer--error--hidden"
    );
    this.errorMessage.innerText = message;
  }

  hideCartErrorMessage() {
    this.errorEl.classList.add("complementary__content--footer--error--hidden");
    this.errorMessage.innerText = "";
  }

  addLoadingClass(type = "single") {
    switch (type) {
      case "single":
        this.singleSwatchBtn.classList.add("complementary__button--loading");
        break;
      case "multi":
        this.multipleSwatchBtn.classList.add("complementary__button--loading");
        break;
      case "trigger":
        if (this.triggerBtn)
          this.triggerBtn?.classList?.add(
            "product-info__complementary-button--loading"
          );
        break;
    }
  }

  removeLoadingClass(type = "single") {
    switch (type) {
      case "single":
        this.singleSwatchBtn.classList.remove("complementary__button--loading");
        break;
      case "multi":
        this.multipleSwatchBtn.classList.remove(
          "complementary__button--loading"
        );
        break;
      case "trigger":
        if (this.triggerBtn)
          this.triggerBtn?.classList?.remove(
            "product-info__complementary-button--loading"
          );
        break;
    }
  }

  handleCartCountBubble(html) {
    const count = html
      .querySelector("cart-drawer")
      .getAttribute("data-cart-items-count");

    if (!count) {
      console.error("No cart count found");
      return;
    }

    const cartCountElements = document.querySelectorAll(
      "span.cart-item-count-header.cart-item-count-header--quantity"
    );

    // bubble
    const cartCountBubbles = document.querySelectorAll(
      "span.cart-item-count-header.cart-item-count-header--dot"
    );

    if (cartCountElements.length === 0 && cartCountBubbles.length === 0) {
      console.error("No cart count elements found");
      return;
    }

    if (cartCountElements.length) {
      cartCountElements.forEach((element) => {
        element.textContent = count;
      });
    }

    if (cartCountBubbles.length) {
      cartCountBubbles.forEach((element) => {
        if (Number.parseInt(count) > 0) {
          element.classList.remove("cart-item-count-header--dot-hidden");
        } else {
          element.classList.add("cart-item-count-header--dot-hidden");
        }
      });
    }
  }

  handleButtonTextChange(
    type = "single",
    temporaryLabel = "Added",
    delay = 1000
  ) {
    let buttonEl = null;

    switch (type) {
      case "single":
        buttonEl = this.singleSwatchBtn;
        break;
      case "multi":
        buttonEl = this.multipleSwatchBtn;
        break;
    }

    if (!buttonEl) {
      console.error("No button element found");
      return;
    }

    const labelEl = buttonEl.querySelector(".complementary__button--text");

    if (!labelEl) {
      console.error("No label element found");
      return;
    }

    if (buttonEl._resetTextTimer) {
      clearTimeout(buttonEl._resetTextTimer);
      buttonEl._resetTextTimer = null;
    }

    const oldLabel = labelEl.innerText;
    labelEl.innerHTML = temporaryLabel;

    buttonEl._resetTextTimer = setTimeout(() => {
      labelEl.innerHTML = oldLabel;
    }, delay);
  }

  handleUpdateCartDrawer(html) {
    const formBody = html.querySelector("form.cart-drawer__content--body");

    if (!formBody) {
      console.error("No form body found");
      return;
    }

    const cartDrawer = document.querySelector("cart-drawer");

    if (cartDrawer && typeof cartDrawer.handleBodyReRender === "function") {
      cartDrawer.handleBodyReRender(formBody.innerHTML);
    }
  }

  handleShowCartDrawer() {
    const cartDrawer = document.querySelector("cart-drawer");

    if (cartDrawer && typeof cartDrawer.handleOpen === "function") {
      cartDrawer.handleOpen();
    }
  }

  handleCartUpdates(html, hasError, type) {
    // update cart count
    this.handleCartCountBubble(html);

    // update cart drawer
    this.handleUpdateCartDrawer(html);

    if (hasError) {
      return;
    }

    switch (this.addToCartMode) {
      case "message":
        this.handleButtonTextChange(type);
        break;
      case "drawer":
        this.handleShowCartDrawer();
        break;
      case "none":
        break;
      default:
        location.href = "/cart";
        break;
    }
  }

  async handleMultiSwatchAddToCart() {
    let actionsNotNeeded = false;

    if (!this.isMultiSwatchAvailable && !this.multiSwatchId) {
      actionsNotNeeded = true;
      return;
    }

    try {
      this.addLoadingClass("multi");

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: this.multiSwatchId,
              quantity: 1,
            },
          ],
        }),
      });
      const data = await response.json();
      if (!response.ok)
        throw new Error(
          data?.description || data?.message || "Error adding to cart."
        );

      await this.handleRemoveSingleSwatchFromCart();

      this.hideCartErrorMessage();
    } catch (error) {
      actionsNotNeeded = true;
      this.showCartErrorMessage(error.message);
      console.error("Error adding to cart:", error);
    } finally {
      this.removeLoadingClass("multi");
      const cart = await this.getCartHtml();
      this.handleCartUpdates(
        new DOMParser().parseFromString(cart["cart-drawer-new"], "text/html"),
        actionsNotNeeded,
        "multi"
      );
    }
  }

  async handleSingleSwatchAddToCart() {
    let actionsNotNeeded = false;
    try {
      if (!this.isSingleSwatchAvailable || !this.singleSwatchId) {
        actionsNotNeeded = true;
        return;
      }

      // check single swatch and multi swatch already in cart
      const isInCart = await this.handleCheckSwatchAlreadyInCart(this.singleSwatchId)
      if (isInCart) {
        actionsNotNeeded = true;
        return;
      }
      if (this.isMultiSwatchAvailable && this.multiSwatchId) {
        this.addLoadingClass("single");
      } else {
        this.addLoadingClass("trigger");
      }

      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          items: [
            {
              id: this.singleSwatchId,
              quantity: 1,
            },
          ],
        }),
      });

      const data = await response.json();
      if (!response.ok)
        throw new Error(
          data?.description || data?.message || "Error adding to cart."
        );
      this.hideCartErrorMessage();
    } catch (error) {
      actionsNotNeeded = true;
      this.showCartErrorMessage(error.message);
      console.error("Error adding to cart:", error);
    } finally {
      if (this.isMultiSwatchAvailable && this.multiSwatchId) {
        this.removeLoadingClass("single");
      } else {
        this.removeLoadingClass("trigger");
      }
      const cart = await this.getCartHtml();
      this.handleCartUpdates(
        new DOMParser().parseFromString(cart["cart-drawer-new"], "text/html"),
        actionsNotNeeded,
        "single"
      );
    }
  }

  async getCartHtml() {
    try {
      const response = await fetch(
        `${window.Shopify.routes.root}cart?sections=cart-drawer-new`
      );
      const data = await response.json();
      if (!response.ok) throw new Error(data?.description || data?.message);
      return data;
    } catch (error) {
      console.error("Error getting cart:", error);
    }
  }

  async handleCheckSwatchAlreadyInCart(swatchId) {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`);
      const cart = await response.json();

      if (!response.ok)
        throw new Error(
          cart?.description || cart?.message || "Error getting cart."
        );

      if (!cart.items.length) return false;

      const isInCart = cart.items.some((item) => item?.id === Number(swatchId));
      return isInCart;
    } catch (error) {
      throw error;
    }
  }

  async handleRemoveSingleSwatchFromCart() {
    try {
      if (!this.isSingleSwatchAvailable || !this.singleSwatchId) return;

      const isInCart = await this.handleCheckSwatchAlreadyInCart(this.singleSwatchId);
      if (!isInCart) return;

      const response = await fetch(
        `${window.Shopify.routes.root}cart/change.js`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            id: this.singleSwatchId,
            quantity: 0,
          }),
        }
      );

      const data = await response.json();

      if (!response.ok)
        throw new Error(
          data?.description || data?.message || "Error removing from cart."
        );
    } catch (error) {
      throw error;
    }
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.clickHandler);
    document.removeEventListener(
      "variant:contentUpdated",
      this.variantUpdateHandler
    );
  }
}

customElements.define("complementary-products", ComplementaryProducts);
